module.exports = __webpack_public_path__ + "img/bg.73ab2853.jpg";